import styled from "styled-components";
import React, {useEffect, useState} from "react";
import {mainColor, selectStyle, whiteColor} from "../../assets/GlobalStyles";
import {useAtom} from "jotai";
import {Controller, useForm} from "react-hook-form";
import {ModalBody, ModalFooter, ModalHeader} from "../modal/Modal";
import Select from "react-select";
import {inquiryTypes} from "../../pages/customer/entity/NoticeEntity";
import {modalController} from "../../store";

export default function WriteNoticeModal(props) {
  const {formType, title, onClick, buttonText, userId} = props;
  const [, setModal] = useAtom(modalController)
  useEffect(()=>{
    return ()=> {
      onClose()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  const onClose = () => {
    setModal({ isShow: false })
  }

  const handleModalComponent = () => {
    setModal({
      isShow: true,
      width: 760,
      blur: true,
      modalComponent: () => {
        return (
          <WriteForm formType={formType} title={title} onSubmitProps={onClick} onClose={onClose} userId={userId}/>
        )
      }
    })
  }
  return (
      <Button type={'button'} onClick={handleModalComponent}>{buttonText}</Button>
  )
}

function WriteForm(props) {
  const { formType, title, onSubmitProps, onClose, userId } = props;
  const [notice, setNotice] = useState({title: '', content: ''});
  const [noticePublish, setNoticePublish] = useState({publishYn: 'N'});
  const [inquiryType, setInquiryType] = useState({id: 0, value: 'ADVER_INQUIRY', label:'광고 문의'});
  const {control, handleSubmit, clearErrors, formState: {errors}} = useForm({
    mode: "onSubmit"
  })

  const onError = (error) => console.log(error);
  const onSubmit = () => {
    const payload={...notice};
    if(formType.indexOf('notice') > -1){
      Object.assign(payload, noticePublish);
    }else{
      Object.assign(payload, {inquiryType: inquiryType.value, userId: userId});
    }
    onSubmitProps(payload);
    onClose();
  };

  const handleSearchType = (data) => {
    setInquiryType(data)
  }

  return (
      <ModalFormShell>
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <ModalHeader title={title} variant="search"/>
          <ModalBody>
            <Intro>
              <strong>{formType.indexOf('notice') > -1 ? "공지사항 정보" : "문의 정보"}</strong>
              <span>제목과 내용을 입력하고 공개 상태를 확인한 뒤 저장해 주세요.</span>
            </Intro>
            <FormCard>
              <FormField>
                <FieldLabel>제목<Required>*</Required></FieldLabel>
                <InputWrap>
                  <Controller
                      name="title"
                      control={control}
                      rules={{required: '제목을 입력해 주세요.'}}
                      render={({field}) => (
                          <ModalInput type={'text'}
                                 {...field}
                                 value={notice?.title}
                                 placeholder={'제목을 입력해주세요.'}
                                 onChange={(e) => {
                                   field.onChange(e);
                                   setNotice({...notice, title: e.target.value})
                                   clearErrors('title')
                                 }}
                          />)}
                      />
                  {errors.title && <Validation>{errors.title.message}</Validation>}
                </InputWrap>
              </FormField>
              <FormField $top>
                <FieldLabel>내용<Required>*</Required></FieldLabel>
                <InputWrap>
                  <Controller
                      name="content"
                      control={control}
                      rules={{required: '내용을 입력해 주세요.'}}
                      render={({field}) => (
                          <ModalTextArea rows={12}
                                    {...field}
                                    placeholder={'내용을 입력해주세요.'}
                                    value={notice?.content}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setNotice(
                                          {...notice, content: e.target.value})
                                      clearErrors('content')
                                    }}
                          />)}
                      />
                  {errors.content && <Validation>{errors.content.message}</Validation>}
                  <CharacterCount>{notice.content.length.toLocaleString()}자</CharacterCount>
                </InputWrap>
              </FormField>
            {formType.indexOf('notice') > -1 ?
                <FormField>
                    <FieldLabel>공개 여부</FieldLabel>
                    <Segmented>
                      <PublishOption $active={noticePublish?.publishYn === 'Y'}>
                        <input
                            type={'radio'}
                            name={'notice'}
                            id={'publishY'}
                            onChange={() => setNoticePublish({publishYn: 'Y'})}
                            checked={noticePublish?.publishYn === 'Y'}
                        />
                        <span><StatusDot/>공개</span>
                      </PublishOption>
                      <PublishOption $active={noticePublish?.publishYn === 'N'} $danger>
                        <input
                            type={'radio'}
                            name={'notice'}
                            id={'publishN'}
                            onChange={() => setNoticePublish({publishYn: 'N'})}
                            checked={noticePublish?.publishYn === 'N'}
                        />
                        <span><StatusDot/>비공개</span>
                      </PublishOption>
                      <PublishGuide>{noticePublish.publishYn === "Y" ? "저장 즉시 사용자에게 공개됩니다." : "관리자만 확인할 수 있는 상태로 저장됩니다."}</PublishGuide>
                    </Segmented>
                </FormField>
                :
                <FormField>
                    <FieldLabel>문의 구분</FieldLabel>
                    <InputWrap>
                      <Select styles={selectStyle}
                              width={150}
                              isSearchable={false}
                              options={inquiryTypes.filter((d,i)=> i!==0)}
                              value={inquiryType.value !== '' ? inquiryTypes.find(
                                      type => type.value === inquiryType.value)
                                  : inquiryTypes[1]}
                              onChange={handleSearchType}
                      />
                    </InputWrap>
                </FormField>
            }
            </FormCard>
          </ModalBody>
          <ModalFooter>
            <Cancel type={"button"} onClick={onClose}>취소</Cancel>
            <Submit type={"submit"}>{'저장'}</Submit>
          </ModalFooter>
        </form>
      </ModalFormShell>
  )
}

const Button = styled.button`
  width: 140px;
  height: 35px;
  border-radius: 5px;
  font-size: var(--font-size-16);
  cursor: pointer;
  border: 1px solid;
  color: ${mainColor};
  background-color:  ${whiteColor};
  border-color:  ${mainColor};

  &:hover {
    color: ${whiteColor};
    background-color:  ${mainColor};
    border-color:  ${whiteColor};
  }
`
const ModalFormShell=styled.div`
  form{margin:0;}
  main{padding:22px 25px 24px;background:var(--color-surface);}
  footer{justify-content:flex-end;padding:16px 25px;background:#f8fafc;}
  footer button{width:110px;height:40px;margin:0 0 0 8px;border-radius:7px;font-size: var(--font-size-13);font-weight:700;}
`;
const Intro=styled.div`
  margin-bottom:14px;padding-left:11px;border-left:3px solid ${({theme})=>theme.color.subColor};
  strong,span{display:block;}strong{color:#20242b;font-size: var(--font-size-16);font-weight:750;}
  span{margin-top:5px;color:#8a939d;font-size: var(--font-size-12);}
`;
const FormCard=styled.div`overflow:hidden;border:1px solid #e2e7ec;border-radius:10px;background:var(--color-surface);`;
const FormField=styled.div`
  display:grid;grid-template-columns:120px minmax(0,1fr);gap:18px;padding:17px 20px;border-bottom:1px solid var(--color-divider);
  &:last-child{border-bottom:0;}@media(max-width:600px){grid-template-columns:1fr;gap:8px;}
`;
const FieldLabel=styled.label`padding-top:12px;color:#444;font-size: var(--font-size-13);font-weight:700;`;
const Required=styled.span`margin-left:4px;color:var(--color-danger);`;
const InputWrap=styled.div`position:relative;min-width:0;`;
const ModalInput=styled.input`
  width:100%;height:42px;padding:0 13px;border:1px solid #dce2e8;border-radius:7px;background:var(--color-surface);color:#333;font-size: var(--font-size-13);outline:0;
  &:focus{border-color:var(--color-primary);box-shadow:0 0 0 3px rgba(59,130,246,.1);}::placeholder{color:#a8b0b8;}
`;
const ModalTextArea=styled.textarea`
  width:100%;min-height:230px;padding:13px;border:1px solid #dce2e8;border-radius:7px;background:var(--color-surface);color:#333;font-size: var(--font-size-13);line-height:1.65;resize:vertical;outline:0;
  &:focus{border-color:var(--color-primary);box-shadow:0 0 0 3px rgba(59,130,246,.1);}::placeholder{color:#a8b0b8;}
`;
const Validation=styled.p`margin:6px 0 0;color:#e05252;font-size: var(--font-size-11);`;
const CharacterCount=styled.span`display:block;margin-top:6px;color:#9aa2aa;font-size: var(--font-size-11);text-align:right;`;
const Segmented=styled.div`display:flex;align-items:center;gap:8px;min-height:42px;flex-wrap:wrap;`;
const PublishOption=styled.label`
  display:inline-flex;align-items:center;justify-content:center;height:34px;padding:0 14px;border:1px solid ${({$active,$danger})=>$active?($danger?"#f0b9b9":"#aedfc6"):"#dfe4e9"};
  border-radius:7px;background:${({$active,$danger})=>$active?($danger?"#fff2f2":"#edf9f3"):"var(--color-surface)"};color:${({$active,$danger})=>$active?($danger?"#c94545":"#168253"):"#737c85"};
  font-size: var(--font-size-12);font-weight:700;cursor:pointer;input{position:absolute;opacity:0;pointer-events:none;}span{display:flex;align-items:center;gap:6px;}
`;
const StatusDot=styled.i`width:6px;height:6px;border-radius:50%;background:currentColor;`;
const PublishGuide=styled.span`margin-left:4px;color:#929ba5;font-size: var(--font-size-11);`;
const Cancel=styled.button`border:1px solid #cfd5db;background:var(--color-surface);color:#555;`;
const Submit=styled.button`border:1px solid var(--color-primary-strong);background:var(--color-primary-strong);color:var(--color-surface);&:hover{background:var(--color-primary-dark);}`;
